module.exports = __webpack_public_path__ + "img/de.53f92be7.png";